import { Container, Typography, Box } from '@mui/material';

const AboutPage = () => {
    return(
        <Container maxWidth="md" sx={{ mt: 10 }}>
            <Typography variant="h4" gutterBottom>
                About LegalDescriptionConverter:
            </Typography>
            <Box sx={{ mb: 2 }}>
                <Typography paragraph>
                    Together we are going to save you hours of data processing.
                    We are building all the tools you'll need to convert your legal descriptions into usable sets of data. Like GIS shapefiles and feature classes.
                </Typography>
                <Typography paragraph>
                    You can input your legal description, text or PDF, into a converter. Run. And have the data format you need.
                </Typography>
                <Typography paragraph>
                    Easy as that.
                </Typography>

                {/* COGO Genie GIF */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                <img 
                    src="https://i.imgur.com/Kg3dzbk.gif"
                    alt="COGO Genie in Action"
                    style={{ width: '65%', height: 'auto', borderRadius: '8px' }}
                />
                </Box>
                

            </Box>
        </Container>
    )
}

export default AboutPage;